/**
 * Un plugin qui rajoute un directive v-visible qui permet de controler le style de visibility (visible ou hidden) dans le style d'un v-show. Cela peut être utilie quand il y des boutons dans un v-tab par exemple pour conserver la taille du v-tab que le bouton soit visible ou non
 */
export default {
  install(Vue) {
    Vue.directive('visible', function(el, binding) {
      el.style.visibility = binding.value ? 'visible' : 'hidden';
    });
  },
};
